import React from 'react';
import { Tiles } from 'wsm-tiles';
import { useRequestData } from 'wsm-common-data';
import { usePrefs } from 'ws-scripts/modules/common';
import { useGroupLogos } from '../hooks/useGroupLogos';
import { MOBILE, TILE_SIZE_MAP } from '../global-constants';
import MiniGridView from '../components/MiniGridView';

const Widget = () => {
	const { layout, exposedLabel, tileSize } = usePrefs();
	const requestData = useRequestData();
	const isMobile = requestData.deviceType === MOBILE;
	const showLabel = exposedLabel === 'true';
	const groupLogos = useGroupLogos(showLabel);

	// On mobile, show, mini-grid view when "carousel" layout is selected
	if (isMobile && layout === 'carousel') {
		return <MiniGridView />;
	}

	return (
		<Tiles
			type="brand"
			data={groupLogos}
			layout={layout}
			tileSize={TILE_SIZE_MAP[tileSize]}
			className={layout === 'grid' ? 'justify-content-center' : ''}
		/>
	);
};

export default Widget;
